import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import moment from 'moment';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import { InputSwitch } from 'primereact/inputswitch';
import useDynamicRefs from 'use-dynamic-refs';
import {inputTextValidate} from '../utilities/Validate'

export const Componente = React.forwardRef(({ obj = null, label = '', tipo = '', value = '', name = '0', size = 4, readonly = true, opciones = null,
    getDataSave, getRef, setRef,getRefFrm , checkboxValue = [] }, refff) => {

    const [obj_, setObj_] = useState(obj);
    const [label_, setLabel_] = useState(label);
    const [tipo_, setTipo_] = useState(tipo);
    const [value_, setValue_] = useState(value == null ? '' : value);
    const [name_, setName_] = useState(name);
    const [size_, setSize_] = useState(size);
    const [opciones_, setOpciones_] = useState([]);
    const [sino_, setSino_] = useState(opciones);
    const [readonly_, setReadonly_] = useState(true);
    const [radioValue_, setRadioValue_] = useState('');
    const [checkboxValue_, setCheckboxValue_] = useState(checkboxValue);

    const aa = [];
    aa[name] = useRef();


    const onCheckboxChange = (e) => {
        let selectedValue = [...checkboxValue_];
        if (e.checked)
            selectedValue.push(e.value);
        else
            selectedValue.splice(selectedValue.indexOf(e.value), 1);

        setCheckboxValue_(selectedValue);
    };

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {

        if (name !== '0') {
            //debugger;
            let objP = { idrespuesta: obj.idrespuesta, respuesta: value == null ? '' : value, ini: true };

            if (!obj.readonly || obj.dependiente === 1) getDataSave(name, objP);
            setTipo_(tipo);
            setLabel_(label);
            // setValue_(value==null?'':value);
            setName_(name);
            setSize_(size);
            setSino_(opciones);
            setReadonly_(readonly);

            if (opciones !== null && (tipo === 'Dropdown' || tipo === 'RadioButton')) {

                let dat = opciones.split('|');
                let array = [];

                dat?.map((val, index) => {
                    if (val.length > 0) array.push({ value: val });
                })

                setOpciones_(array);
            }

            if (tipo === 'InputSwitch') {

                setValue_(value === null || value === '' || value == "NO" ? false : true);
            } else {
                setValue_(value === null ? '' : value);

            }

        }

        setObj_(obj)

    }, [obj]);


    const monthNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{ lineHeight: 1 }} />;
    }

    const yearNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} className="ml-2" style={{ lineHeight: 1 }} />;

    }

    const onCheckboxChangee = (e) => {
        let selectedValue = [...checkboxValue_];
        if (e.checked)
            selectedValue.push(e.value);
        else
            selectedValue.splice(selectedValue.indexOf(e.value), 1);

        setCheckboxValue_(selectedValue);
    };


    const onInputChange = (e, name) => {


        if (e.target === undefined) return;

        let val = (e.target && e.target.value) || '';
        //setValue_(val)
        if (e.target.name === 'fecha') {
            val = moment(val).format("YYYY-MM-DD");
        }

        if (e.target.name === 'radio') {
            //  setRadioValue_(val)
        }
       
        if (e.target.name === 'InputText' && e.target.dataset.dependiente === '1') {
            if(readonly_) setReadonly_(false)
            getRef(e.target.id).current.className = 'p-inputtext p-component'
        }

        if (e.target.name === 'InputText' || e.target.name === 'InputTextarea') {
            let dff = inputTextValidate(val);
            if (!dff) return;
        }

        if (e.target.name === 'checkOption') {
           // selectedValue = value_.split('|');
           // if (selectedValue.indexOf(val) < 0) {
             //   if (val.length > 0) selectedValue.push(val);
           // } else {
             //   if (val.length > 0) selectedValue.splice(selectedValue.indexOf(val), 1);
           // }
           // val = selectedValue.filter(x => x !== '').join('|');
           if (e.target.checked) {
            val = label_
           }else{
            val = '';
           }

        }

        if (e.target.name === 'SI,NO') {
            if (val) {
                val = 'SI';
                setValue_(true)
            } else {
                val = 'NO';
                setValue_(false)
            }
        } else {
            setValue_(val)

        }

        let objP = { idrespuesta: null, respuesta: val, ini: false };
        getDataSave(name, objP);
        // Incrementar el inputNumber hijo dependientes del checkbox
        if (e.target.name === 'checkOption' && e.target.id.idhijo !== undefined && e.target.id.idhijo !== null) {

            let valRef = getRef(e.target.id.idhijo).current.inputRef.current.value;
            let valorInput = valRef.length>0?parseInt(valRef):0;

            if (e.target.checked) {
                valorInput = valorInput+1;
            }else{
                valorInput = valorInput-1;
            }

            objP = { idrespuesta: null, respuesta: valorInput, ini: false };
            getDataSave(e.target.id.idhijo, objP);
            getRef(e.target.id.idhijo).current.inputRef.current.value = valorInput
        }

        // check (enabled, disabled y nulo)
        if (e.target.name === 'checkOption') {

            if (e.target.id.nulo !== '') {
                let ids = e.target.id.nulo.split(',');
                ids?.map((id, index) => {
                    if (id.length > 0) {
                        //debugger;
                        //let dd = getRefFrm();
                        //console.log(dd)
                        if (e.target.checked) {
                            if (getRef(id).current.inputRef.current.checked) {
                                let o = { idrespuesta: null, respuesta: '', ini: false };
                                getDataSave(id, o);
                                getRef(id).current.inputRef.current.click();
                            }
                        }
                    }
                })
            }

            if (e.target.id.disabled !== '') {
                let ids = e.target.id.disabled.split(',');
                ids?.map((id, index) => {
                    if (id.length > 0) {
                        let o = { idrespuesta: null, respuesta: '', ini: false };
                        getDataSave(id, o);
                        let children = getRef(id).current.children;
                        for (var i = 0; i < children.length; i++) {
                            children[i].children[0].checked = false
                            children[i].children[0].disabled = true
                        }

                    }
                })
            }

            if (e.target.id.enabled !== '') {
                let ids = e.target.id.enabled.split(',');
                ids?.map((id, index) => {
                    if (id.length > 0) {
                        let o = { idrespuesta: null, respuesta: '', ini: false };
                        getDataSave(id, o);
                        let children = getRef(id).current.children;
                        for (var i = 0; i < children.length; i++) {
                            children[i].children[0].checked = false
                            if (e.target.checked) {
                                children[i].children[0].disabled = false
                            } else {
                                children[i].children[0].disabled = true
                            }
                        }
                    }
                })
            }

            if (e.target.id.enabled_disabled !== '') {
                let ids = e.target.id.enabled_disabled.split(',');
                ids?.map((id, index) => {
                    if (id.length > 0) {
                        let o = { idrespuesta: null, respuesta: '', ini: false };
                        getDataSave(id, o);
                        //debugger;
                        getRef(id).current.value = '';
                        getRef(id).current.defaultValue = '';
                        
                        if (e.target.checked) {
                            getRef(id).current.disabled = false
                            getRef(id).current.className = 'p-inputtext p-component'
                            getRef(id).current.readOnly = false
                            
                        }else{
                            getRef(id).current.disabled = true
                            getRef(id).current.className = 'p-inputtext p-component p-disabled'
                            getRef(id).current.readOnly = true
                        }
                    }
                })
            }



        }

    }

    useEffect(() => {
        if (obj.dependiente === 1) {
            setRef(name, aa[name]);
            //console.log(obj)
        }
    }, [obj]);

    const setCheck = (value) => {
        let dat = value_.split('|');
        let result = dat.indexOf(value) !== -1
        return result;
    }

    const getComponente = () => {

        switch (tipo_) {
            case 'InputText':
                return <InputText name="InputText" ref={obj_.dependiente === 1 ? aa[obj_.id] : null} readOnly={readonly_} id={obj_.id} data-dependiente={obj_.dependiente} disabled={readonly_} type="text" value={value_} onChange={(e) => onInputChange(e, name_)} />
            case 'InputTextarea':
                return <InputTextarea name="InputTextarea" ref={obj_.dependiente === 1 ? aa[obj_.id] : null} value={value_} id={{ ...obj_ }} disabled={readonly_} placeholder="contenido" autoResize rows="3" cols="30" onChange={(e) => onInputChange(e, name_)} />
            case 'InputNumber':
                return <InputNumber ref={obj_.dependiente === 1 ? aa[obj_.id] : null} value={value_} id={{ ...obj_ }} disabled={readonly_} onValueChange={(e) => onInputChange(e, name_)} showButtons mode="decimal"></InputNumber>
            case 'Dropdown':
                return <Dropdown ref={obj_.dependiente === 1 ? aa[obj_.id] : null} value={value_} id={{ ...obj_ }} disabled={readonly_} onChange={(e) => onInputChange(e, name_)} options={opciones_} optionLabel="value" optionValue="value" placeholder="Seleccionar..." />
            case 'MultiSelect':
                return <InputNumber ref={obj_.dependiente === 1 ? aa[obj_.id] : null} value={value_} id={{ ...obj_ }} readOnly={readonly_} onValueChange={(e) => onInputChange(e, name_)} showButtons mode="decimal"></InputNumber>
            case 'InputSwitch':
                return <div className="p-field-radiobutton p-mt-2 p-mb-1">
                    <InputSwitch ref={obj_.dependiente === 1 ? aa[obj_.id] : null} disabled={readonly_} name={sino_} id={{ ...obj_ }} checked={value_} onChange={(e) => onInputChange(e, name_)} />
                    <label htmlFor="option1">{label_}</label>
                </div>
            case 'RadioButton':
                let disabledd = false;
                let check = false;
                opciones_?.map((o, i) => {
                    if (obj_.dependiente === 1){
                        if(o.value === value_){
                            check = true
                        }
                    }
                })

                if (obj_.dependiente === 1){
                    disabledd = check?false:true;
                }

                if(readonly_){
                    disabledd = readonly_;
                }

                return <div className="p-grid" ref={obj_.dependiente === 1 ? aa[obj_.id] : null}>

                    {opciones_?.map((obj, index) => {

                        return <React.Fragment key={index}>
                            <div className="p-field-radiobutton p-mt-2 p-mb-1 p-ml-2 p-mr-3" >
                                {/*    <RadioButton ref={obj_.dependiente === 1 ? aa[obj_.id] : null} disabled={false} name="radio" id={{ ...obj_ }} value={obj.value} checked={obj.value === value_} onChange={(e) => onInputChange(e, name_)} />
                                <label htmlFor="option1">{obj.value}</label>
                                */}
                                <input type="radio" key={index} disabled={disabledd} name={obj_.id} id={{ ...obj_ }} value={obj.value} checked={obj.value === value_} onChange={(e) => onInputChange(e, name_)} />
                                <label htmlFor="option1">{obj.value}</label>

                            </div>

                        </React.Fragment>;
                    })}

                </div>;

            case 'Checkbox':
                return <div className="p-grid">
                    <div className="p-field-checkbox p-mt-2 p-mb-1 p-ml-2 p-mr-3" >
                        <Checkbox ref={obj_.dependiente === 1 ? aa[obj_.id] : null} disabled={readonly_} name="checkOption" id={{ ...obj_ }} readOnly={readonly_} value={value_} checked={label_ === value_} onChange={(e) => onInputChange(e, name_)} />
                        <label htmlFor="checkOption">{label_}</label>

                        {/*
                             <input type="checkbox" data-prop={{ ...obj_ }} ref={obj_.dependiente === 1 ? aa[obj_.id] : null} name="checkOption" id={{ ...obj_ }} value={obj.value} checked={setCheck(obj.value)} onChange={(e) => onInputChange(e, name_)}/> 
                             <label htmlFor="checkOption">{obj.value}</label>
                        */}

                    </div>
                </div>;

            case 'Calendar':
                let fecha = '';
                if (value_ !== '') {
                    fecha = new Date(value_)
                    fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset())
                }

                return <Calendar ref={obj_.dependiente === 1 ? aa[obj_.id] : null} id="spanish" readOnlyInput readOnly={readonly_} disabled={readonly_} value={fecha} name="fecha" onChange={(e) => onInputChange(e, name_)} locale="es" dateFormat="dd/mm/yy" monthNavigator yearNavigator yearRange="1980:2030" showIcon monthNavigatorTemplate={monthNavigatorTemplate} yearNavigatorTemplate={yearNavigatorTemplate} />

            default:
                return ''
        }

    }


    const getSize = () => {

        switch (size_) {
            case 1:
                return 'p-col-12 p-md-6 p-lg-3 p-mb-0'
            case 2:
                return 'p-col-12 p-md-6 p-lg-6 p-mb-0'
            case 3:
                return 'p-col-12 p-md-6 p-lg-9 p-mb-0'
            case 4:
                return 'p-col-12 p-md-6 p-lg-12 p-mb-0'
            default:
                return 'p-col-12 p-md-6 p-lg-12 p-mb-0'
        }
    }

    return (

        (tipo_ === 'InputSwitch' || tipo_ === 'Checkbox') ?
            <div className={getSize()}>
                {getComponente()}
            </div> :
            <div className={getSize()}>
                <div className="p-pb-1">{label_} </div>
                {getComponente()}
            </div>

    );
})